import RequetArtist from "./RequetArtist";

const Admin = () => {
  return <RequetArtist />;
};

export default Admin;
